import { create } from "zustand";

type UseIsStickyPollenNavStoreType = {
  isSticky: boolean;
  setIsSticky: (val: boolean) => void;
  resetIsSticky: () => void;
};

const initialState = {
  isSticky: false,
};

const useIsStickyPollenNavStore = create<UseIsStickyPollenNavStoreType>(
  set => ({
    ...initialState,
    setIsSticky: val =>
      set({
        isSticky: val,
      }),
    resetIsSticky: () => set(initialState),
  })
);

export default useIsStickyPollenNavStore;
